import React from 'react';
import WeatherDisplay from '../WeatherDisplay';
import './Home.css';

export const HomeWeatherCard: React.FC = () => (
  <section className="home-weather-card">
    <WeatherDisplay />
  </section>
);

export default HomeWeatherCard;
